var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "keep-alive",
    [
      _vm.routerViewKey
        ? _c("router-view", {
            key: _vm.routerViewKey,
            attrs: {
              "profile-owner": _vm.profileOwner,
              permissions: _vm.permissions
            }
          })
        : _c("playlists-view", {
            key: "static-playlists",
            attrs: {
              "profile-owner": _vm.profileOwner,
              permissions: _vm.permissions
            }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }